import React, { useState } from "react";
import { useWeddingData } from "../hooks/useWeddingData";
import Map from "./Map";
import NavigationLinks from "./NavigationLinks";
import "./LocationSection.css";

const LocationSection: React.FC = () => {
  const { weddingData, loading } = useWeddingData();
  const [showGroomModal, setShowGroomModal] = useState(false);
  const [showBrideModal, setShowBrideModal] = useState(false);

  if (loading || !weddingData) {
    return <div className="location-section loading">로딩 중...</div>;
  }

  // 계좌번호가 있는 사람만 필터링
  const groomAccounts = weddingData.groom?.bankAccounts || {};
  const brideAccounts = weddingData.bride?.bankAccounts || {};

  const hasGroomAccounts = Object.values(groomAccounts).some(
    (account: any) => account?.accountNumber && account?.bankName
  );
  const hasBrideAccounts = Object.values(brideAccounts).some(
    (account: any) => account?.accountNumber && account?.bankName
  );

  // 계좌번호 복사 함수
  const copyToClipboard = async (accountNumber: string, label: string) => {
    try {
      // 하이픈 제거하고 숫자만 추출
      const cleanAccountNumber = accountNumber.replace(/[^0-9]/g, "");

      await navigator.clipboard.writeText(cleanAccountNumber);
      alert(
        `${label} 계좌번호가 복사되었습니다.\n\n복사된 계좌번호: ${cleanAccountNumber}`
      );
    } catch (err) {
      // 클립보드 API가 지원되지 않는 경우 대체 방법
      const textArea = document.createElement("textarea");
      const cleanAccountNumber = accountNumber.replace(/[^0-9]/g, "");
      textArea.value = cleanAccountNumber;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      alert(
        `${label} 계좌번호가 복사되었습니다.\n\n복사된 계좌번호: ${cleanAccountNumber}`
      );
    }
  };

  const renderAccountItem = (label: string, account: any) => {
    if (!account?.accountNumber || !account?.bankName) return null;

    // 라벨에 실명 추가
    let displayLabel = label;
    if (label === "신랑" && weddingData.groom?.name) {
      displayLabel = `신랑 (${weddingData.groom.name})`;
    } else if (label === "신부" && weddingData.bride?.name) {
      displayLabel = `신부 (${weddingData.bride.name})`;
    } else if (label === "신랑 아버지" && weddingData.groom?.fatherName) {
      displayLabel = `신랑 아버지 (${weddingData.groom.fatherName})`;
    } else if (label === "신랑 어머니" && weddingData.groom?.motherName) {
      displayLabel = `신랑 어머니 (${weddingData.groom.motherName})`;
    } else if (label === "신부 아버지" && weddingData.bride?.fatherName) {
      displayLabel = `신부 아버지 (${weddingData.bride.fatherName})`;
    } else if (label === "신부 어머니" && weddingData.bride?.motherName) {
      displayLabel = `신부 어머니 (${weddingData.bride.motherName})`;
    }

    return (
      <div className="account-item" key={label}>
        <span className="label">{displayLabel}</span>
        <div className="account-row">
          <span className="bank">{account.bankName}</span>
          <span className="account">{account.accountNumber}</span>
          <button
            className="copy-button"
            onClick={() => copyToClipboard(account.accountNumber, displayLabel)}
            title="계좌번호 복사"
          >
            복사
          </button>
        </div>
      </div>
    );
  };

  return (
    <section className="location-section">
      <div className="location-header">
        <h2 className="section-title">오시는 길</h2>
      </div>

      <div className="location-content">
        <div className="location-group">
          <div className="map-container">
            <Map
              location={
                weddingData.venue || {
                  name: "",
                  address: "",
                  latitude: 0,
                  longitude: 0,
                }
              }
            />
          </div>
          <div className="navigation-links-container">
            <NavigationLinks
              location={
                weddingData.venue || {
                  name: "",
                  address: "",
                  latitude: 0,
                  longitude: 0,
                }
              }
            />
          </div>
        </div>

        {/* {weddingData.directions && weddingData.directions.trim() && (
          <div className="directions-info">
            <h3>오시는 길 상세 안내</h3>
            <div
              className="directions-content"
              dangerouslySetInnerHTML={{
                __html: weddingData.directions,
              }}
            />
          </div>
        )} */}

        <div className="bank-info">
          <h3>마음 전하실 곳</h3>
          <div className="bank-buttons">
            {hasGroomAccounts && (
              <button
                className="bank-button groom-button"
                onClick={() => setShowGroomModal(true)}
              >
                👨 신랑측 계좌번호
              </button>
            )}
            {hasBrideAccounts && (
              <button
                className="bank-button bride-button"
                onClick={() => setShowBrideModal(true)}
              >
                👩 신부측 계좌번호
              </button>
            )}
          </div>
        </div>
      </div>

      {/* 신랑측 계좌번호 모달 */}
      {showGroomModal && (
        <div className="modal-overlay" onClick={() => setShowGroomModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>신랑측 계좌번호</h3>
              <button
                className="modal-close"
                onClick={() => setShowGroomModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {renderAccountItem("신랑", groomAccounts.self)}
              {renderAccountItem("신랑 아버지", groomAccounts.father)}
              {renderAccountItem("신랑 어머니", groomAccounts.mother)}
            </div>
          </div>
        </div>
      )}

      {/* 신부측 계좌번호 모달 */}
      {showBrideModal && (
        <div className="modal-overlay" onClick={() => setShowBrideModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>신부측 계좌번호</h3>
              <button
                className="modal-close"
                onClick={() => setShowBrideModal(false)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {renderAccountItem("신부", brideAccounts.self)}
              {renderAccountItem("신부 아버지", brideAccounts.father)}
              {renderAccountItem("신부 어머니", brideAccounts.mother)}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default LocationSection;
